import dataroomUrl from '@/dataroom/infrastructure/dataroomUrl';
import dataroomConfig from '@dataroom/config';
import Tooltip from '@dealroadshow/uikit/core/components/Tooltip';
import { ProductAbbreviations } from '@/finsight/domain/Product';
import CorrectionButton from '@/finsight/ui/components/deals/CorrectionModal/CorrectionButton';
import CorrectionModalProvider from '@/finsight/ui/components/deals/CorrectionModal/CorrectionModalContext';
import IconExpand from '@dealroadshow/uikit/core/components/Icon/IconExpand';
import IconCollapse from '@dealroadshow/uikit/core/components/Icon/IconCollapse';
import IconCheck from '@dealroadshow/uikit/core/components/Icon/IconCheck';
import IconInvestorSet from '@dealroadshow/uikit/core/components/Icon/IconInvestorSet';
import type IDealCellData from '@/finsight/ui/components/deals/DealListTable/cells/types';

import styles from '@/finsight/ui/components/deals/DealListTable/cells/Tools/tools.scss';

const Tools = ({ row: deal, isExpanded }: { row: IDealCellData, isExpanded: boolean }) => {
  const renderExpandCollapseIcon = () => {
    const Icon = isExpanded ? IconCollapse : IconExpand;
    const tooltip = isExpanded ? 'Collapse' : 'Expand';

    return (
      <Tooltip content={ tooltip }>
        <Icon data-test={ `dealRow-${ isExpanded ? 'collapse' : 'expand' }` } />
      </Tooltip>
    );
  };

  return (
    <div className={ styles.toolsCol }>
      <CorrectionButton
        selectedDeal={ deal }
      />
      <div className={ styles.tool }>
        <div className={ styles.expandCollapseBtn }>
          { renderExpandCollapseIcon() }
        </div>
      </div>
      <div className={ styles.tool }>
        { deal.verified && !deal.investorSetAvailable && (
          <Tooltip content="Transaction Details Verified">
            <IconCheck
              className={ styles.verified }
              data-test="dealRowVerified"
            />
          </Tooltip>
        ) }
        { deal.investorSetAvailable && (
          <div className={ styles.investorSetAvailable }>
            <a
              target="_blank"
              href={ deal.product.abbreviation === ProductAbbreviations.ABS
                ? dataroomUrl(dataroomConfig.tenant.tenantInvestorSet.code)
                  .getExploreSetsABSUrl()
                : dataroomUrl(dataroomConfig.tenant.tenantInvestorSet.code)
                  .getExploreSetsCorporateUrl() }
              data-test="dealRowInvestorSetLink"
              onClick={ (e) => e.stopPropagation() }
            >
              <Tooltip content="Transaction documentation is available on InvestorSet">
                <IconInvestorSet />
              </Tooltip>
            </a>
          </div>
        ) }
      </div>
    </div>
  );
};

export default (props) => (
  <CorrectionModalProvider>
    <Tools { ...props } />
  </CorrectionModalProvider>
);
